import React, { FormEvent, useState, useRef, ChangeEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import AuthLayout from '../../layouts/Auth';
import { AuthInput } from '../../reusables/Inputs';

import classListModifier from "../../../utils/classListModifier";
import validator from "../../../utils/validator";

import useSignIn from "../../../hooks/auth/useSignIn";

export type SignInput = {
  value: string;
  validationError: string | null;
}
const Login = () => {
  const signInUsernameContRef = useRef<HTMLDivElement | null>(null);
  const signInPasswordContRef = useRef<HTMLDivElement | null>(null);

  const [signInUsername, setSignInUsername] = useState<SignInput>({ value: '', validationError: null });
  const [signInPassword, setSignInPassword] = useState<SignInput>({ value: '', validationError: null });
  const [isProcessRunning, setIsProcessRunning] = useState<boolean | null>(null);
  const [serviceError, setServiceError] = useState<string | null>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const { mutate: signInMutation } = useSignIn();

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "signInUsername") {
      setSignInUsername({ ...signInUsername, value: value })
    } else if (name === 'signInPassword') {
      setSignInPassword({ ...signInPassword, value: value });
    }
  }

  const preProcessSignIn = () => {
    const usernameValidation = validator.validate('username', signInUsername.value);
    const passwordValidation = validator.validate('password', signInPassword.value);

    const signInUsernameContClassList = signInUsernameContRef?.current?.classList;
    const signInPasswordContClassList = signInPasswordContRef?.current?.classList;

    if (!signInUsernameContClassList || !signInPasswordContClassList) return;

    const ERROR_CLASS = 'auth_input_container__error';

    if (usernameValidation?.missMsg) {
      classListModifier.add(signInUsernameContClassList, ERROR_CLASS);
      setSignInUsername({ ...signInUsername, validationError: usernameValidation.missMsg || null });
    } else {
      classListModifier.remove(signInUsernameContClassList, ERROR_CLASS);
      setSignInUsername({ ...signInUsername, validationError: null });
    }

    if (passwordValidation?.missMsg) {
      classListModifier.add(signInPasswordContClassList, ERROR_CLASS);
      setSignInPassword({ ...signInPassword, validationError: passwordValidation.missMsg });
    } else {
      classListModifier.remove(signInPasswordContClassList, ERROR_CLASS);
      setSignInPassword({ ...signInPassword, validationError: null });
    }

    if (usernameValidation?.missMsg || passwordValidation?.missMsg) return;

    return true;
  };

  const onSignIn = (e: FormEvent) => {
    e.preventDefault();

    if (!preProcessSignIn()) return;

    signInMutation({
      payload: {
        username: signInUsername.value,
        password: signInPassword.value,
      },
      setIsProcessRunning: setIsProcessRunning,
      setServiceError: setServiceError,
      callback: () => {
        navigate(location?.state?.from?.pathname ?? '/', { replace: true })
      }
    });
  };


  return (
    <AuthLayout>
      <div className='imm_admin__login__page_view'>
        <h2>Admin Sign In</h2>
        <form onSubmit={onSignIn} noValidate className='sign_in_form'>
          <AuthInput
            label='Username'
            type='text'
            name='signInUsername'
            id='signInUsername'
            placeholder='Your Username'
            onChange={onChangeInput}
            value={signInUsername.value}
            error={signInUsername.validationError}
            containerRef={signInUsernameContRef}
          />

          <AuthInput
            label='Password'
            type='password'
            isPasswordToggle={true}
            name='signInPassword'
            id='signInPassword'
            placeholder='Your Password'
            onChange={onChangeInput}
            value={signInPassword.value}
            error={signInPassword.validationError}
            containerRef={signInPasswordContRef}
          />

          {serviceError &&
            <p className='service_error_msg'>{serviceError}</p>
          }

          <div className='action_btns_group'>
            <button
              type='submit'
              className='imm_admin__btn__primary btn_block'
              disabled={isProcessRunning !== null}
            >
              {isProcessRunning ? <i className='imm_admin__btn_loader' /> : 'Sign In'}
            </button>
          </div>
        </form>
      </div>
    </AuthLayout>
  )
}

export default Login